import {
    AdditionalCostCostSplitDetailsDto,
    AdditionalCostDetailsDto,
    ChildId,
    CostAllocationRefersTo,
} from 'types';
import { DetailsColumn, DetailsRow, AppCardListItem } from 'components/atoms';
import { settlementTexts } from 'consts/text';
import { payerMapper } from 'consts/settlementChildren/payerMapper';
import { referToMapper } from 'consts/settlementChildren/referToMapper';
import { PriceDisplay } from 'components/molecules/Table/PriceDisplay/PriceDisplay';
import { useIsMobile } from 'hooks/useIsMobile/useIsMobile';
import { AdditionalCostInvoice } from 'components/templates/settlement/ChildSettlementDetails/AdditionalCostList/AdditionalCostItem/AdditionalCostDetails/AdditionalCostInvoice';

type Props = {
    childId: ChildId;
    detailsDto: AdditionalCostDetailsDto;
    idx: number;
    record: AdditionalCostCostSplitDetailsDto;
};

export const ParentAdditionalCostSplitDetails = ({
    childId,
    detailsDto: _detailsDto,
    idx,
    record,
}: Props) => {
    const isMobile = useIsMobile();

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: 16,
                alignItems: 'flex-start',
                width: '100%',
            }}
        >
            <div style={{ flex: 1 }}>
                <AppCardListItem key={record.id} index={idx} listItem={record}>
                    <DetailsRow>
                        <DetailsColumn
                            title={settlementTexts.children.costSplit.institutionName}
                            span={16}
                        >
                            {record.foundationName}
                        </DetailsColumn>
                    </DetailsRow>
                    <DetailsRow>
                        <DetailsColumn title={settlementTexts.children.costSplit.nip} span={6}>
                            {record.nip}
                        </DetailsColumn>
                        <DetailsColumn
                            title={settlementTexts.children.costSplit.finalAmount}
                            span={6}
                        >
                            {record.finalGrossAmount ? (
                                <PriceDisplay value={record.finalGrossAmount} />
                            ) : (
                                '-'
                            )}
                        </DetailsColumn>
                        <DetailsColumn
                            title={settlementTexts.children.costSplit.percentageAmount}
                            span={6}
                        >
                            {record.percentageAmount ? `${record.percentageAmount} %` : '-'}
                        </DetailsColumn>
                        <DetailsColumn
                            title={settlementTexts.children.costSplit.payerType}
                            span={6}
                        >
                            {payerMapper[record.payerType]}
                        </DetailsColumn>
                    </DetailsRow>
                    <DetailsRow>
                        <DetailsColumn title={settlementTexts.children.costSplit.refersTo} span={6}>
                            {referToMapper[record.costCategory as CostAllocationRefersTo]}
                        </DetailsColumn>
                        <DetailsColumn
                            title={settlementTexts.children.costSplit.invoiceNotes}
                            span={12}
                        >
                            {record.invoiceNotes}
                        </DetailsColumn>
                    </DetailsRow>
                </AppCardListItem>
            </div>

            {record.invoiceData && (
                <div
                    style={{
                        width: isMobile ? '100%' : 320,
                        flexShrink: 0,
                    }}
                >
                    <AdditionalCostInvoice
                        childId={childId}
                        invoiceData={record.invoiceData}
                        isParent
                        title="Rozliczenie"
                    />
                </div>
            )}
        </div>
    );
};
